import React from "react";
import {animated} from "react-spring";
import * as PropTypes from "prop-types";

class Speaker extends React.Component {

    render() {
        return <div className="col-lg-4 col-md-6" onClick={()=>{
            this.props && this.props.onClick(this.props);
        }}>
            <animated.div style={this.props.style} className="speaker" data-aos="fade-up" data-aos-delay="100">
                <img src={this.props.imageSrc} alt={this.props.imageAlt} className="img-fluid" style={{
                    maxHeight: "250px"
                }}/>
                <div className="details">
                    <h3><a href={this.props.href}>{this.props.name}</a></h3>
                    <p>{this.props.title}</p>
                    <div className="social">
                        {this.props.twitterHref && <a href={this.props.twitterHref}><i className="fa fa-twitter"/></a>}
                        {this.props.facebookHref && <a href={this.props.facebookHref}><i className="fa fa-facebook"/></a>}
                        {this.props.googlePlusHref && <a href={this.props.googlePlusHref}><i className="fa fa-google-plus"/></a>}
                        {this.props.linkedInHref && <a href={this.props.linkedInHref}><i className="fa fa-linkedin"/></a>}
                    </div>
                </div>
            </animated.div>
        </div>;
    }
}

Speaker.propTypes = {
    style: PropTypes.any,
    imageSrc: PropTypes.string,
    imageAlt: PropTypes.string,
    href: PropTypes.string,
    name: PropTypes.any,
    title: PropTypes.any,
    twitterHref: PropTypes.string,
    facebookHref: PropTypes.string,
    googlePlusHref: PropTypes.string,
    linkedInHref: PropTypes.string
};

class Bio extends React.Component {
    render() {
        return <animated.div style={{...this.props.style}} className="container">
            <div id="bio" style={{paddingTop: "25px"}} className="section-header">
                <h2>{this.props.speaker.name}</h2>
                <h3>{this.props.speaker.title}</h3>
            </div>
            <div>
                <p style={{whiteSpace: "pre-line"}}>{this.props.speaker.bio}</p>
            </div>
        </animated.div>;
    }
}

Bio.propTypes = {
    style: PropTypes.any,
    speaker: PropTypes.any,
    onClick: PropTypes.func
};

export class Speakers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            speaker: null
        }
    }

    render() {
        return <section id="speakers">
             <animated.div style={this.props.style} className="container">
                <div className="section-header">
                    <h2>Speakers</h2>
                    <p>
                        {
                            !this.props.tbd ?
                                "Our awesome speakers!" :
                                this.props.open  ? "CFP are now open! Please submit" : "CFPs will be announced shortly"
                        }
                    </p>
                </div>
                <div className={"row"}>
                    {this.state.speaker &&
                        <Bio speaker={this.state.speaker}/>
                    }
                </div>

                <div className="row">
                    {
                        !this.props.tbd ?
                            this.getListOfSpeakers()
                            : this.getTbd(this.props.open)
                    }
                </div>
            </animated.div>
        </section>;
    }

    getListOfSpeakers() {
        return this.props.speakers && this.props.speakers.map(speaker => <>
                <Speaker
                    style={this.props.style}
                    imageSrc={speaker.imageSrc}
                    imageAlt={speaker.imageAlt}
                    href={speaker.href}
                    name={speaker.name}
                    title={speaker.title}
                    twitterHref={speaker.twitterHref}
                    facebookHref={speaker.facebookHref}
                    googlePlusHref={speaker.googlePlusHref}
                    linkedInHref={speaker.linkedInHref}
                    onClick={()=>{
                        this.setState({
                            speaker: speaker
                        }, () => {
                            var elmnt = document.getElementById("bio");
                            elmnt.scrollIntoView();
                        });
                    }}
                />
            </>
        );
    }

    getTbd(open) {
        return <div className={"col-md-4 offset-md-4"}>
            {open && <button className={"subscribe-button"} type="submit" onClick={() => {
                    document.location.href = "https://forms.gle/a8tJDnpUh7sbsZBa7";
                }}>Submit Paper
                </button>}
            </div>;
    }
}

Speakers.propTypes = {style: PropTypes.any, speakers: PropTypes.array};